import { z } from 'zod';

export const isoDatetimeToDate = z.codec(z.iso.datetime(), z.date(), {
  decode: (isoString) => new Date(isoString),
  encode: (date) => date.toISOString(),
});

/** Numbers arrive as strings in query strings. */
export const stringToNumber = z.codec(z.string(), z.number(), {
  decode: (string) => Number(string),
  encode: (number) => String(number),
});

export const stringToStringArray = z.codec(z.string(), z.array(z.string()), {
  decode: (string) => string.split(','),
  encode: (array) => array.join(','),
});

export const stringToUuidArray = z.codec(z.string(), z.array(z.uuid()), {
  decode: (string) => string.split(','),
  encode: (array) => array.join(','),
});
